import { css, keyframes } from 'styled-components';

const slideInRightToLeft = keyframes`
    from { transform: translateX(-100vw); }
    to { transform: translateX(0); }
`;

const slideInLeftToRight = keyframes`
    from { transform: translateX(100vw); }
    to { transform: translateX(0); }
`;

export const slideRightToLeftAnimation = css`
    animation: ${slideInRightToLeft} 0.25s ease-out;
`;

export const slideLeftToRightAnimation = css`
    animation: ${slideInLeftToRight} 0.25s ease-out;
`;
